import List from './list/ReferralStatusListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})